











































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '../../../../../components/Modal.vue'
import ScrollView from '../../../../../components/ScrollView.vue'
import { ITableConfig } from '@/interfaces'
import Table from '@/components/tables/Table.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'

@Component({
  components: {
    Table,
    ScrollView,
    Modal,
    DateTimeLabel
  },
  props: {
    appliedTo: {
      type: Array,
      required: true
    },
    payment: {
      required: true
    },
    depositDate: {
      required: true
    }
  }
})
export default class DepositPaymentsModal extends Vue {
  config: ITableConfig = {
    maxHeight: '240px',
    columns: [
      {
        key: 'effectiveDate',
        label: 'Effective Date',
        width: 33
      },
      {
        key: 'payerType',
        label: 'Payer Type',
        width: 33
      },
      {
        key: 'paymentAmount',
        label: 'Payment Amount',
        width: 33
      }
    ]
  }
  get appliedToAndSurcharge (): any[] {
    let appliedToAndSurcharge: any[] = []
    if (!this.$props.payment) {
      return appliedToAndSurcharge
    }
    if (this.$props.appliedTo) {
      appliedToAndSurcharge.push(...this.$props.appliedTo)
    }
    if (this.$props.payment.surcharge && Number(this.$props.payment.surcharge) !== 0) {
      const surchargeLine = this.getSurchargeRow(this.$props.payment)
      appliedToAndSurcharge.push(surchargeLine)
    } else {
      const originalPayment: any = this.$props.payment.originalPayment
      if (originalPayment && originalPayment.surcharge && Number(originalPayment.surcharge) !== 0) {
        const surchargeLine = this.getSurchargeRow(originalPayment, true)
        appliedToAndSurcharge.push(surchargeLine)
      }
    }
    return appliedToAndSurcharge
  }

  getSurchargeRow (payment: any, isNegative = false) {
    const transactionType = payment.transactionType.toLowerCase()
    let surchargeType
    if (transactionType.includes('echeck')) {
      surchargeType = 'Echeck Convenience Fee'
    } else if (transactionType.includes('cc') && !transactionType.includes('echeck')) {
      surchargeType = 'CC Convenience Fee'
    } else {
      surchargeType = 'CC/Echeck Convenience Fee'
    }

    const surcharge: { surchargeType: string, surchargeAmount: any } = {
      surchargeType,
      surchargeAmount: isNegative ? -1 * payment.surcharge : payment.surcharge
    }
    return surcharge
  }
}
